var render = function render(){var _vm=this,_c=_vm._self._c;return _c('geko-base-crud',{attrs:{"config":_vm.config,"hideList":true},scopedSlots:_vm._u([{key:"create-form",fn:function(){return [_c('program-soc-farmer-form')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }